import { useQuery } from 'src/graphql';
import { CHECKLIST_VERSIONS_QUERY } from 'src/graphql/checklist/query';

export default ({ id, offset, limit, orderBy, orderDirection}) =>
  useQuery(CHECKLIST_VERSIONS_QUERY, {
    variables: { checklistId: id, offset, limit,  orderBy, orderDirection},
    fetchPolicy: 'network-only',
  });
